import { s } from '@/theme/tokens';
import { Box, Text } from '@/ui/primitives';
import { landingCopy } from './landingCopy';
import type { ReactElement } from 'react';

type TestingChangedSectionProps = {
  width: number;
};

const renderBullet = (bullet: string): ReactElement => {
  if (bullet.includes('(and when)')) {
    const [before, after] = bullet.split('(and when)');
    return (
      <Text role="bodyMuted" component="span">
        {before}(
        <Box component="span" sx={{ fontStyle: 'italic' }}>
          and when
        </Box>
        ){after}
      </Text>
    );
  }

  if (bullet.includes("(it's always that one test)")) {
    const [before, after] = bullet.split("(it's always that one test)");
    return (
      <Text role="bodyMuted" component="span">
        {before}(
        <Box component="span" sx={{ fontStyle: 'italic' }}>
          it&apos;s always that one test
        </Box>
        ){after}
      </Text>
    );
  }

  return (
    <Text role="bodyMuted" component="span">
      {bullet}
    </Text>
  );
};

export const TestingChangedSection = ({ width }: TestingChangedSectionProps): ReactElement => (
  <Box component="section">
    <Box sx={{ maxWidth: width, mx: 'auto' }}>
      <Text role="sectionTitle" component="h2" transform="none" mb="lg">
        {landingCopy.testingChanged.sectionTitles.awareness}
      </Text>
      {landingCopy.testingChanged.awarenessParagraphs.map((paragraph, index) => (
        <Text
          key={paragraph}
          role="bodyMuted"
          component="p"
          mb={index === landingCopy.testingChanged.awarenessParagraphs.length - 1 ? '2xl' : 'md'}
        >
          {paragraph}
        </Text>
      ))}

      <Text role="sectionTitle" component="h2" transform="none" mb="lg">
        {landingCopy.testingChanged.sectionTitles.struggles}
      </Text>
      <Box
        component="ul"
        sx={{
          m: s('none'),
          pl: s('xl'),
          color: 'text.secondary',
          mb: `calc(${s('2xl')} + ${s('lg')})`,
          display: 'grid',
          rowGap: s('sm'),
        }}
      >
        {landingCopy.testingChanged.bullets.map((bullet) => (
          <li key={bullet}>{renderBullet(bullet)}</li>
        ))}
      </Box>

      <Text role="sectionTitle" component="h2" transform="none" mb="lg">
        {landingCopy.testingChanged.sectionTitles.conclusion}
      </Text>
    </Box>
  </Box>
);
